module.exports = __webpack_public_path__ + "img/source_icon.da3030c7.svg";